<template lang="pug">
.page
  ui-page-header(title='管线项目管理')
  ui-stage
    .section-select-project
      ui-flex(row, between, a-center)
        ui-flex(row, a-center, wrap)
          strong 请选择项目：
          ui-data-select(
            v-model='projectId',
            :options='projects',
            @input='handleSelectProject($event)'
          )
          LoadingIndicator.ml(:loading='projectsLoading')
        .ml(@click='handleSelectProject(projectId)', :style='{ flex: "0 0 auto" }')
          ui-icon.cursor-pointer(name='refresh')
    div(:class='{ "opacity-mask": !projectId }')
      .mb(v-if='sections && sections.length > 0')
        el-tabs(v-model='currentSection', @tab-click='handleTabClick')
          el-tab-pane(
            v-for='sectionItem in sections',
            :key='sectionItem',
            :label='sectionItem',
            :name='`SECTION_${sectionItem}`'
          )
          el-tab-pane(name='预览')
            span(slot='label')
              i.el-icon-view
              | 预览
      ui-section-title 每日安全交底
        LoadingIndicator.ml(
          :loading='noticeState.loading',
          :editing='noticeState.editing',
          :done.sync='noticeState.done'
        )
      template(v-if='isSecurity')
        ui-data-select.mb(
          v-model='noticeWorkState',
          placeholder='今日是否作业',
          :options='optionsNoticeWorkState',
          @input='submitNotice',
          :disabled='!effectiveCanEdit'
        )
      template(v-else)
        ui-input.mb(readonly, :value='noticeWorkState === "否" ? "不作业" : "今日作业"')
      ui-input(
        type='textarea',
        autosize,
        v-model='notice',
        @input='() => { noticeState.editing = true; submitNoticeDebounced(); }',
        :readonly='!effectiveCanEdit'
      )
      div 今日作业内容：
      ui-input(
        type='textarea',
        autosize,
        v-model='noticeWorkContent',
        @input='() => { noticeState.editing = true; submitNoticeDebounced(); }',
        :readonly='!effectiveCanEdit'
      )
      ui-section-title 施工部位
        LoadingIndicator.ml(
          :loading='dangerZoneAreasState.loading',
          :done.sync='dangerZoneAreasState.done'
        )
      ui-flex.section-title-hint(row, between, a-center)
        span
          ui-icon.mr(name='info')
          | 勾选今日作业的施工部位，添加照片视为完成交底
        ui-button(
          v-if='isSg && !isPreviewMode',
          size='small',
          @click='createDangerZoneAreaState.display = true'
        )
          ui-icon.mr(name='edit')
          | 新建施工部位
      table.el-table.management-table
        tbody
          tr(v-for='item in dangerZoneAreas', :key='item.id')
            td(:width='280')
              ui-checkbox(
                v-model='selectedDangerZones[item.dangerZoneId]',
                @input='handleCheckDangerZoneArea($event, item.dangerZoneId)',
                :disabled='!effectiveCanEdit'
              ) {{ item.title }}
            td
              template(
                v-if='dangerZoneGrants[item.dangerZoneId] && selectedDangerZones[item.dangerZoneId]'
              )
                ui-uploads(
                  v-model='dangerZoneGrants[item.dangerZoneId].images',
                  @input='saveDangerZoneGrant(item.dangerZoneId, $event)',
                  :readonly='!effectiveCanEdit'
                )
              ui-button.opacity-0.pointer-events-none(v-else) 上传照片交底
        ui-dialog(title='新建施工部位', :visible.sync='createDangerZoneAreaState.display')
          div(v-loading='createDangerZoneAreaState.loading')
            ui-form
              ui-form-item(label='施工部位名称')
                ui-input.p-form-input(placeholder='施工部位名称', v-model='createDangerZoneArea.title')
            .p-submit
              ui-button(type='primary', @click='handleCreateDangerZoneArea')
                ui-icon.mr(name='check')
                | 新建施工部位
      ui-section-title 设备作业
        LoadingIndicator.ml(
          :loading='dangerZoneDevicesState.loading',
          :done.sync='dangerZoneDevicesState.done'
        )
      ui-flex.section-title-hint(row, a-center, between)
        span
          ui-icon.mr(name='info')
          | 勾选今日作业的危险源设备，添加照片视为完成交底
        ui-button(
          size='small',
          @click='createDangerZoneDeviceState.display = true',
          v-if='isSg && !isPreviewMode'
        )
          ui-icon.mr(name='edit')
          | 新建设备
      table.el-table.management-table
        tbody
          tr(v-for='item in dangerZoneDevices', :key='item.id')
            td(:width='280')
              ui-checkbox(
                v-model='selectedDangerZones[item.dangerZoneId]',
                @input='handleCheckDangerZone($event, item.dangerZoneId)',
                :disabled='!effectiveCanEdit'
              ) {{ item.title }}
            td
              template(
                v-if='dangerZoneGrants[item.dangerZoneId] && selectedDangerZones[item.dangerZoneId]'
              )
                ui-uploads(
                  v-model='dangerZoneGrants[item.dangerZoneId].images',
                  @input='saveDangerZoneGrant(item.dangerZoneId, $event, "dangerZoneDevicesState")',
                  :readonly='!effectiveCanEdit'
                )
              ui-button.opacity-0.pointer-events-none(v-else) 上传照片交底
        ui-dialog(title='新建设备', :visible.sync='createDangerZoneDeviceState.display')
          div(v-loading='createDangerZoneDeviceState.loading')
            ui-form
              ui-form-item(label='设备名称')
                ui-input.p-form-input(placeholder='设备名称', v-model='createDangerZoneDevice.title')
            .p-submit
              ui-button(type='primary', @click='handleCreateDangerZoneDevice')
                ui-icon.mr(name='check')
                | 新建设备
      ui-section-title 作业人员安全交底
        LoadingIndicator(:loading='workersState.loading', :done.sync='workersState.done')
      ui-flex.section-title-hint(row, between, a-center)
        span
          ui-icon.mr(name='info')
          | 上传全体人员合照（一张或多张），然后勾选今日入场的作业人员
        ui-dropdown(
          split-button,
          type='primary',
          size='small',
          @click='createWorkerState.display = true',
          v-if='isSg && !isPreviewMode',
          @command='handleCommandNewMembers'
        )
          ui-icon.mr(name='edit')
          | 新建人员
          template(#dropdown)
            ui-dropdown-menu
              ui-dropdown-item(command='batch-upload') Excel批量上传
      ui-uploads(
        v-model='dailyDangerZoneGrants.images',
        @input='saveDailyDangerZonePhoto($event)',
        :readonly='!effectiveCanEdit'
      )
      ui-flex.p-list(row, wrap, :style='{ minHeight: "32px" }')
        .p-list-item(v-for='item in workers', :key='item.id')
          ui-checkbox(
            v-model='selectedWorkers[item.id]',
            @input='handleToggleWorker(item.id, $event)',
            :disabled='!effectiveCanEdit'
          ) {{ item.display_name }}
            small.text-hint(v-if='item.xDisplayUsername') （{{ item.username }}）
        ui-dialog(
          title='批量上传人员',
          :visible.sync='batchUploadWorkersState.display',
          @close='handleSelectProject(projectId)'
        )
          div(v-if='batchUploadWorkersState.stage === "upload"')
            ui-upload(
              v-model='batchUploadWorkersState.file',
              :before-upload='handleUploadBatchMembers',
              drag
            )
              div(:style='{ padding: "20px" }') 请选择或拖入要上传的Excel文件
          div(v-else-if='batchUploadWorkersState.stage === "list"')
            ui-alert(
              :closable='false',
              type='warning',
              v-if='!batchUploadWorkersState.done && !batchUploadWorkersState.loading'
            )
              .mb 请确认以下内容正确
              ui-button(type='primary', @click='handleSubmitBatchMembers') 执行导入
              ui-button(@click='handleBatchUploadMembers') 重新上传
            ui-alert(
              type='success',
              v-else-if='!batchUploadWorkersState.loading && batchUploadWorkersState.done'
            ) 已完成批量提交，请检查数据状态，然后关闭此弹窗
            table.el-table.excel-table
              thead
                th 姓名
                th 身份证号
                th 手机号
                th 工种
                th 备注
              tbody
                tr(v-for='(item, index) in batchUploadWorkersState.list', :key='index')
                  td {{ item.姓名 }}
                  td {{ item.身份证号 }}
                  td {{ item.手机号 }}
                  td {{ item.工种 }}
                  td {{ item.state }}
        ui-dialog(title='新建人员', :visible.sync='createWorkerState.display')
          ui-loading(:loading='createWorkerState.loading')
            ui-form
              ui-form-item(label='姓名')
                ui-input.p-form-input(placeholder='姓名', v-model='createWorker.display_name')
              ui-form-item(label='身份证号')
                ui-input.p-form-input(placeholder='身份证号', v-model='createWorker.id_card')
              ui-form-item(label='手机号')
                ui-input.p-form-input(placeholder='手机号', v-model='createWorker.mobile')
              ui-form-item(label='工种')
                ui-data-select.p-form-input(
                  placeholder='工种',
                  v-model='createWorker.position',
                  allow-create,
                  :options='optionsPosition'
                )
            .p-submit
              ui-button(type='primary', @click='handleSubmitWorker')
                ui-icon.mr(name='check')
                | 新建人员
      template(v-if='isAboveJl')
        .section-title-hint.warning(:style='{ marginTop: "64px" }') 监理单位管理人员操作：
        ui-section-title 监理日志
          LoadingIndicator.ml(
            :loading='supervisionLogState.loading',
            :done.sync='supervisionLogState.done'
          )
        .section-title-hint
          ui-icon.mr(name='info')
          | 监理单位管理人员应当每日上传
          router-link(to='/admin/supervision-logs')
            ui-link.ml(type='primary') 监理日志
          | 、
          router-link(to='/admin/supervision-e-logs')
            ui-link(type='primary') 电子监理日志
        ui-input.mb(
          type='textarea',
          v-model='supervisionLog.text',
          :readonly='!isJl',
          placeholder='监理日志内容',
          @input='saveSupervisionLog',
          :autosize='{ minRows: 5 }'
        )
        ui-uploads(v-model='supervisionLog.images', :readonly='!isJl', @input='saveSupervisionLog')
        ui-section-title 管线监理审核
          LoadingIndicator(
            :loading='supervisionSimpleManagementStates.loading',
            :done.sync='supervisionSimpleManagementStates.done'
          )
        .section-title-hint
          ui-icon.mr(name='info')
          | 监理单位管理人员应当每日对以上数据进行审核
        .mt(v-if='isJl')
          ui-button(@click='submitSupervisionSimpleManagement')
            ui-icon.mr(name='success')
            | 审核
        ul
          li.ul-item(v-for='item in supervisionSimpleManagements', :key='item.id') {{ formatDateTime(item.createdAt) }} {{ item.createdBy && item.xUser.display_name }}
</template>

<script>
import { vue, _, moment, G } from '@yishitec/web';
import withConfirm from '../../../mixins/withConfirm';

export default {
  name: 'SimpleProjectManagementIndex',
  components: {
    LoadingIndicator: () => import('./sections/LoadingIndicator.vue'),
  },
  mixins: [withConfirm],
  data() {
    const projectDefault = {
      isAboveJl: false,
      isJl: false,
      isSg: false,
      isSecurity: false,

      projectsLoading: false,
      optionsNoticeWorkState: [
        { title: '今日施工', value: '是' },
        { title: '不施工', value: '否' },
      ],
      noticeWorkState: '是',
      notice: '',
      noticeWorkContent: '',
      noticeState: {
        loading: false,
        editing: false,
        done: false,
      },
      dangerZoneAreas: [],
      createDangerZoneArea: {
        title: '',
      },
      createDangerZoneAreaState: {
        display: false,
        loading: false,
      },
      dangerZoneAreasState: {
        loading: false,
        done: false,
      },
      dangerZoneDevices: [],
      dangerZoneDevicesState: {
        loading: false,
        done: false,
      },
      // displayCreateDangerZoneDevice: false,
      createDangerZoneDeviceState: {
        display: false,
        loading: false,
      },
      createDangerZoneDevice: {
        title: '',
      },
      selectedDangerZones: {},
      dangerZoneGrants: {},
      dangerZoneGrantDefault: {
        dangerZoneId: null,
        images: '',
      },
      workersState: {
        loading: false,
        done: false,
      },
      dailyDangerZoneGrants: {
        images: '',
      },
      photos: '',
      workersCount: null,
      selectedOpsZonesIds: [],
      workers: [],
      createWorkerDefault: {
        display_name: '',
        id_card: '',
        mobile: '',
        position: '',
      },
      createWorker: {
        display_name: '',
        id_card: '',
        mobile: '',
        position: '',
      },
      createWorkerState: {
        display: false,
        loading: false,
      },
      batchUploadWorkersState: {
        display: false,
        file: '',
        list: [],
        loading: false,
        stage: 'upload', // upload, list
        done: false,
      },
      selectedWorkers: {},
      supervisionLog: {
        text: '',
        images: '',
      },
      supervisionLogState: {
        loading: false,
        done: false,
      },
      supervisionSimpleManagements: [],
      supervisionSimpleManagementStates: {
        loading: false,
        done: false,
      },
      sections: [],
      originalNoticeData: null,
    };
    return {
      date: moment().format('YYYY-MM-DD'),
      projects: [
        {
          id: 1,
          title: '测试管线项目',
          value: 1,
        },
      ],
      projectId: null,
      ...projectDefault,
      currentSection: '',
      effectiveCurrentSection: '',
      projectDefault,
      submitNoticeDebounced: _.debounce(this.submitNotice, 300),
      optionsPosition: G().options工种(),
    };
  },
  computed: {
    isPreviewMode() {
      return this.effectiveCurrentSection === '预览';
    },
    currentSectionName() {
      if (this.isPreviewMode) {
        return null;
      }
      if (this.effectiveCurrentSection && this.effectiveCurrentSection.startsWith('SECTION_')) {
        return this.effectiveCurrentSection.replace(/^SECTION_/, '');
      }
      return this.effectiveCurrentSection;
    },
    effectiveCanEdit() {
      return this.isSecurity && !this.isPreviewMode;
    },
    isFormDirty() {
      if (!this.originalNoticeData || this.isPreviewMode) {
        return false;
      }
      return (
        this.notice !== this.originalNoticeData.notice ||
        this.noticeWorkState !== this.originalNoticeData.noticeWorkState ||
        this.noticeWorkContent !== this.originalNoticeData.noticeWorkContent
      );
    },
  },
  async mounted() {
    await this.loadProjects();
    if (this.projects && this.projects.length && !this.projectId) {
      this.projectId = _.get(this.projects, [0, 'id']);
      await this.handleSelectProject(this.projectId);
    }
  },
  methods: {
    resetProjects() {
      _.extend(this, {
        ...this.projectDefault,
      });
    },
    async loadProjects() {
      this.projectsLoading = true;
      this.date = moment().format('YYYY-MM-DD');
      this.resetProjects();
      const { list } = await this.withLoading(this.api('/api/get-simple-projects'));
      this.projects = _.map(list, (item) => {
        return {
          ...item,
          value: item.id,
        };
      });
      this.projectsLoading = false;
    },
    async handleSelectProject(projectId) {
      const { currentSectionName, effectiveCurrentSection } = this;
      this.resetProjects();
      if (!projectId) return;
      this.projectsLoading = true;
      const requestBody = this.isPreviewMode
        ? {
            projectId,
            date: this.date,
            mode: 'view',
          }
        : {
            projectId,
            date: this.date,
            section: currentSectionName,
          };
      const res = await this.withLoading(
        this.api('/api/simple-project-management/project', requestBody),
      );
      _.extend(this, res);

      // Map loaded fields
      if (res.workersPhoto !== undefined) {
        this.dailyDangerZoneGrants.images = res.workersPhoto || '';
      }
      if (res.photos !== undefined) {
        this.photos = res.photos || '';
      }
      if (res.workersCount !== undefined) {
        this.workersCount = res.workersCount;
      }
      if (res.selectedOpsZonesIds !== undefined) {
        this.selectedOpsZonesIds = res.selectedOpsZonesIds || [];
      }

      // Set sections and current section
      if (res.sections && res.sections.length > 0) {
        this.sections = res.sections;
      }
      // Only auto-select first section if not in preview mode and effectiveCurrentSection is not set or invalid
      if (!this.isPreviewMode && this.sections && this.sections.length > 0) {
        const isCurrentSectionValid =
          effectiveCurrentSection &&
          (effectiveCurrentSection.startsWith('SECTION_') ||
            this.sections.includes(effectiveCurrentSection.replace(/^SECTION_/, '')));
        if (
          !effectiveCurrentSection ||
          (!isCurrentSectionValid && effectiveCurrentSection !== '预览')
        ) {
          const [firstSection] = this.sections;
          this.effectiveCurrentSection = `SECTION_${firstSection}`;
          this.currentSection = `SECTION_${firstSection}`;
        }
      }

      // Store original notice data for dirty checking
      this.originalNoticeData = {
        notice: this.notice,
        noticeWorkState: this.noticeWorkState,
        noticeWorkContent: this.noticeWorkContent,
      };

      _.forEach(this.selectedDangerZones, (checked, dangerZoneId) => {
        if (checked) {
          this.initDangerZoneGrant(dangerZoneId);
        }
      });
      this.markWorkerUsernames();
      this.projectsLoading = false;
    },
    markWorkerUsernames() {
      const { workers } = this;
      const dict = _.groupBy(workers, 'display_name');
      _.forEach(dict, (list) => {
        if (list.length > 1) {
          _.forEach(list, (item) => {
            // eslint-disable-next-line no-param-reassign
            item.xDisplayUsername = true;
          });
        }
      });
    },
    async handleCheckDangerZone(
      checked,
      dangerZoneId,
      dangerZoneStateName = 'dangerZoneDevicesState',
    ) {
      if (checked) {
        this.initDangerZoneGrant(dangerZoneId);
      }
      this[dangerZoneStateName].loading = true;
      await this.apiCheckDangerZoneArea(checked, dangerZoneId);
      this[dangerZoneStateName].done = true;
      this[dangerZoneStateName].loading = false;
    },
    initDangerZoneGrant(dangerZoneId) {
      if (!this.dangerZoneGrants[dangerZoneId]) {
        this.dangerZoneGrants[dangerZoneId] = {
          ...this.dangerZoneGrantDefault,
          dangerZoneId,
        };
      }
    },
    async handleCheckDangerZoneArea(checked, dangerZoneId) {
      return await this.handleCheckDangerZone(checked, dangerZoneId, 'dangerZoneAreasState');
    },
    async apiCheckDangerZoneArea(checked, dangerZoneId) {
      await this.withLoading(
        this.api('/api/simple-project-management/toggle-danger-zone', {
          projectId: this.projectId,
          date: this.date,
          section: this.currentSectionName,
          checked,
          dangerZoneId,
        }),
      );
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    getFormCommon() {
      return {
        projectId: this.projectId,
        date: this.date,
      };
    },
    async handleSubmit(url, body, stateName = 'noticeState', replace = false) {
      this[stateName].loading = true;
      const res = await this.withLoading(this.api(url, body));
      if (replace) {
        _.extend(this, res);
      }
      this[stateName].loading = false;
      this[stateName].editing = false;
      this[stateName].done = true;
    },
    async handleTabClick(tab) {
      const newSection = tab.name;
      const previousSection = this.effectiveCurrentSection;

      if (newSection === previousSection) {
        return;
      }

      // Don't check dirty state when switching to/from preview mode (preview is readonly)
      if (newSection !== '预览' && previousSection !== '预览' && this.isFormDirty) {
        try {
          await this.$confirm('有未提交的修改，是否继续编辑？', '提示', {
            confirmButtonText: '留在当前页面',
            cancelButtonText: '放弃未保存的修改',
            type: 'warning',
          });
          this.$nextTick(() => {
            this.currentSection = previousSection;
          });
          return;
        } catch (e) {
          // User cancelled, continue to switch tab
        }
      }

      this.effectiveCurrentSection = newSection;
      await this.handleSelectProject(this.projectId);
    },
    async submitNotice() {
      if (this.isPreviewMode) {
        this.$message({
          type: 'warning',
          message: '预览模式下不能保存',
        });
        return;
      }
      await this.handleSubmit(
        '/api/simple-project-management/save-notice',
        {
          ...this.getFormCommon(),
          notice: this.notice,
          noticeWorkState: this.noticeWorkState,
          noticeWorkContent: this.noticeWorkContent,
          section: this.currentSectionName,
          // photos: this.photos,
          // workersPhoto: this.dailyDangerZoneGrants.images,
          // workersCount: this.workersCount,
          // selectedOpsZonesIds: this.selectedOpsZonesIds,
        },
        'noticeState',
        false,
      );
      // Update original notice data after successful save
      this.originalNoticeData = {
        notice: this.notice,
        noticeWorkState: this.noticeWorkState,
        noticeWorkContent: this.noticeWorkContent,
      };
    },
    async handleModalSubmit(url, body, stateName, formName, replace = true) {
      this[stateName].loading = true;
      const res = await this.withLoading(this.api(url, body));
      if (replace) {
        _.extend(this, res);
      }
      this[formName] = {
        ...this.projectDefault[formName],
      };
      this[stateName].loading = false;
      this[stateName].display = false;
    },
    async handleCreateDangerZoneArea() {
      await this.handleModalSubmit(
        '/api/simple-project-management/save-create-danger-zone-area',
        {
          ...this.getFormCommon(),
          ...this.createDangerZoneArea,
        },
        'createDangerZoneAreaState',
        'createDangerZoneArea',
        true,
      );
    },
    async handleCreateDangerZoneDevice() {
      await this.handleModalSubmit(
        '/api/simple-project-management/save-create-danger-zone-device',
        {
          ...this.getFormCommon(),
          ...this.createDangerZoneDevice,
        },
        'createDangerZoneDeviceState',
        'createDangerZoneDevice',
        true,
      );
    },
    async saveDangerZoneGrant(dangerZoneId, images, stateName = 'dangerZoneAreasState') {
      this[stateName].loading = true;
      const { date, projectId } = this;
      await this.withLoading(
        this.api('/api/simple-project-management/save-danger-zone-grant', {
          date,
          projectId,
          dangerZoneId,
          images,
        }),
      );
      this[stateName].done = true;
      this[stateName].loading = false;
    },
    async saveDailyDangerZonePhoto(images) {
      this.workersState.loading = true;
      const { projectId, date } = this;
      await this.withLoading(
        this.api('/api/simple-project-management/save-daily-notice-images', {
          projectId,
          date,
          section: this.currentSectionName,
          workersPhoto: images,
        }),
      );
      this.workersState.done = true;
      this.workersState.loading = false;
    },
    async handleToggleWorker(workerMemberId, checked) {
      this.workersState.loading = true;
      const { projectId, date } = this;
      await this.withLoading(
        this.api('/api/simple-project-management/toggle-worker-grant', {
          projectId,
          date,
          workerMemberId,
          checked,
        }),
      );
      this.workersState.done = true;
      this.workersState.loading = false;
    },
    async handleSubmitWorker() {
      this.createWorkerState.loading = true;
      const { projectId } = this;
      const res = await this.withLoading(
        this.api('/api/simple-project-management/create-worker', {
          projectId,
          form: this.createWorker,
        }),
      );
      _.extend(this, res);
      this.createWorker = {
        ...this.createWorkerDefault,
      };
      this.createWorkerState.loading = false;
      this.createWorkerState.display = false;
    },
    async saveSupervisionLog() {
      this.supervisionLogState.loading = true;
      const { projectId, date } = this;
      await this.withLoading(
        this.api('/api/simple-project-management/save-supervision-log', {
          projectId,
          date,
          form: this.supervisionLog,
        }),
      );
      this.supervisionLogState.done = true;
      this.supervisionLogState.loading = false;
    },
    async submitSupervisionSimpleManagement() {
      this.supervisionSimpleManagementStates.loading = true;
      const res = await this.withLoading(
        this.api('/api/simple-project-management/save-supervision-simple-management', {
          ...this.getFormCommon(),
        }),
      );
      _.extend(this, res);
      this.supervisionSimpleManagementStates.loading = false;
      this.supervisionSimpleManagementStates.done = true;
    },
    handleCommandNewMembers(command) {
      if (command === 'batch-upload') {
        this.handleBatchUploadMembers();
      }
    },
    resetBatchUploadMembers() {
      this.batchUploadWorkersState = {
        display: false,
        file: '',
        list: [],
        loading: false,
        stage: 'upload',
        done: false,
      };
    },
    handleBatchUploadMembers() {
      this.resetBatchUploadMembers();
      this.batchUploadWorkersState.display = true;
    },
    handleUploadBatchMembers(file) {
      this.handleFile(file);
      return false;
    },
    async handleFile(file) {
      const formData = new FormData();
      formData.append('columns', JSON.stringify(['姓名', '身份证号', '手机号', '工种']));
      formData.append('file', file);
      const res = await this.withLoading(this.api('/api/excel/parse', formData));
      if (!res) {
        this.$message({
          type: 'error',
          message: '无法处理文件',
        });
        this.resetBatchUploadMembers();
        return;
      }
      const { list } = res;
      this.batchUploadWorkersState.list = _.map(list, (item) => {
        return {
          ...item,
          state: '待上传',
        };
      });
      this.batchUploadWorkersState.stage = 'list';
    },
    async handleSubmitBatchMembers() {
      this.batchUploadWorkersState.loading = true;
      // eslint-disable-next-line no-restricted-syntax
      for (const item of this.batchUploadWorkersState.list) {
        const { 姓名, 身份证号, 手机号, 工种 } = item;
        // eslint-disable-next-line no-await-in-loop
        const res = await this.api(
          '/api/simple-project-management/create-worker',
          {
            projectId: this.projectId,
            form: {
              display_name: 姓名,
              id_card: 身份证号,
              mobile: 手机号,
              position: 工种,
            },
          },
          {
            error: (e) => {
              item.state = e.message || '上传失败';
            },
          },
        )();
        if (res) {
          item.state = '已添加';
        }
      }
      this.batchUploadWorkersState.loading = false;
      this.batchUploadWorkersState.done = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.opacity-mask {
  opacity: 0.3;
}

.section-select-project {
  margin: 8px 0;
  background: aliceblue;
  box-sizing: border-box;
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 32px;
}

.management-table {
  th,
  td {
    padding: 4px;
  }
}

.opacity-0 {
  opacity: 0;
}

.section-title-hint {
  color: rgba(#000, 0.3);
  font-size: 14px;
  font-weight: normal;
  margin: 8px 0;
  background: rgba(aliceblue, 0.5);
  box-sizing: border-box;
  padding: 8px;

  &.warning {
    background: rgba(orange, 0.1);
  }
}

.p-form {
  gap: 8px;
}

.p-form-input {
  width: 280px;
}

.p-list {
  gap: 8px;
  box-sizing: border-box;
  padding: 16px 0;
}

.p-list-item {
  flex: 0 0 auto;
  width: calc((100% - 8px * 2) / 3);
  box-sizing: border-box;
  padding: 2px 0;
  height: 40px;
}

.p-submit {
  text-align: center;
  margin-top: 32px;
}

.page {
  :deep(.ui-section-title) {
    margin-top: 32px;
  }

  :deep(.el-form-item__label) {
    width: 120px;
  }
}

.pointer-events-none {
  pointer-events: none;
}

.text-hint {
  color: rgba(#000, 0.3);
}

.ul-item {
  margin: 8px 0;
}

.excel-table {
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #ccc;
    text-align: center;
    padding: 2px;
  }

  th {
    font-weight: bolder;
    color: #000;
  }
}
</style>
